import { faDatabase, faUsers } from "@fortawesome/free-solid-svg-icons"
import StatTile from "./StatTile"

const CARD_ACCENTS = ["violet", "amber", "teal", "sky", "rose", "gray"]

const formatLabel = (value) => (value || "").replace(/_/g, " ")

/*
  Total Records + one card per match-source category, shared between the
  Video Logs and Video Stats pages so both surfaces read the same figure for
  the same filters. Value is distinctCount (distinct accession numbers), not
  the raw record count — matching QR Attached/QR Failed elsewhere, which also
  count distinct accessions rather than rows.
*/
const MatchSourceStatCards = ({ summary, categories }) => (
  <div className="shrink-0 flex flex-wrap gap-3">
    <StatTile
      accent="blue"
      hint="Total records logged in this period"
      icon={faDatabase}
      label="Total Records"
      value={summary?.totalRecords}
    />
    {(categories || []).map((c, index) => (
      <StatTile
        key={c.key}
        accent={CARD_ACCENTS[index % CARD_ACCENTS.length]}
        hint={`Distinct QR codes with match source ${c.key}`}
        icon={faUsers}
        label={formatLabel(c.key)}
        sub={`${
          summary?.totalRecords
            ? Math.round((c.distinctCount / summary.totalRecords) * 100)
            : 0
        }% of total`}
        value={c.distinctCount}
      />
    ))}
  </div>
)

export default MatchSourceStatCards
